import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { PublicHeader } from "@/components/PublicHeader";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { FeedbackButton } from "@/components/FeedbackButton";
import { NotesDrawer } from "@/components/NotesDrawer";
import { InstallPrompt } from "@/components/InstallPrompt";
import { ReadAloudProvider } from "@/context/ReadAloudContext";
import { ReadAloudControls } from "@/components/ReadAloudControls";
import { TrustBarBottom } from "@/components/TrustBar";
import { SafetyButton } from "@/components/SafetyButton";
import { MobileBottomNav } from "@/components/MobileBottomNav";
import { PageGuide } from "@/components/PageGuide";
import { SearchFab } from "@/components/SearchFab";
import { DemoTour } from "@/components/DemoTour";
import { PulaVoice } from "@/components/PulaVoice";
import { UpgradeBanner } from "@/components/UpgradeBanner";
import { HelpDock } from "@/components/HelpDock";

export const PublicLayout = () => {
  const location = useLocation();
  // On full-screen conversation pages, hide floating helpers + the bottom trust ticker
  // so they never cover messages or the "Type a message" box.
  const chatRoutes = ["/chat", "/messages", "/confidante"];
  const isConversation = chatRoutes.some((p) => location.pathname === p || location.pathname.startsWith(p + "/"));
  return (
  <ReadAloudProvider>
    <div className="min-h-screen flex flex-col bg-pula-bg">
      <a href="#main-content" className="skip-link" data-testid="skip-to-content">Skip to main content</a>
      <PublicHeader />
      <UpgradeBanner />
      <main id="main-content" className="flex-1" role="main">
        <Outlet />
      </main>
      {!isConversation && <TrustBarBottom />}
      <Footer />
      {!isConversation && <ChatWidget />}
      {!isConversation && <FeedbackButton />}
      <NotesDrawer />
      {!isConversation && <InstallPrompt />}
      <ReadAloudControls />
      {!isConversation && <SafetyButton />}
      <MobileBottomNav />
      {!isConversation && <PageGuide />}
      {!isConversation && <SearchFab />}
      {!isConversation && <DemoTour />}
      {!isConversation && <PulaVoice />}
      {!isConversation && <HelpDock />}
    </div>
  </ReadAloudProvider>
  );
};
